import UpdateCURPError from './UpdateCURPError';
class CURPAlreadyRejected extends UpdateCURPError {
    constructor() {
        super('Investor CURP is already rejected');
    }
}
export default CURPAlreadyRejected;
